import OrdersAvaliablePaymentTypesRequestV3 from 'api/version3/orders/models/request/OrdersAvaliablePaymentTypesRequestV3';
import { v4 } from 'uuid';
import { Order, User } from '../entities';

export const mapOrderToPaymentTypesRequest = (
  order: Order,
  user: User | null,
): OrdersAvaliablePaymentTypesRequestV3.Request => {
  const isCourier = order.type === 'COURIER';
  const isUrgent = Boolean(order.receiptInformation.urgent);

  return {
    receiptInformation: {
      type: order.type,
      urgent: isUrgent ? true : null,
      timeTo: isUrgent ? null : order.receiptInformation.dateTimeTo,
      receivingAddress: isCourier
        ? order.receiptInformation.receivingAddress
        : null,
      receivingRestaurantId: isCourier
        ? null
        : order.receiptInformation.receivingRestaurant?.id || null,
      dishes: order.dishes.map((dish) => ({
        productId: dish.product.id,
        orderItemId: v4(),
        quantity: dish.quantity,
        base: {
          id: dish.base.id,
          addonGroups: dish.base.addonGroups.map((group) => ({
            id: group.id,
            modifiers: group.modifiers.map((modifier) => ({
              id: modifier.id,
              quantity: modifier.quantity,
            })),
          })),
          selectorGroups: dish.base.selectorGroups.map((group) => ({
            id: group.id,
            modifiers: group.modifiers.map((modifier) => ({
              id: modifier.id,
            })),
          })),
          switchGroups: dish.base.switchGroups.map((group) => ({
            id: group.id,
            modifiers: group.modifiers.map((modifier) => ({
              id: modifier.id,
            })),
          })),
        },
      })),
      constructors: order.constructors.map((constructor) => ({
        productId: constructor.product.id,
        orderItemId: v4(),
        quantity: constructor.quantity,
        base: {
          id: constructor.base.id,
          addonGroups: constructor.base.addonGroups.map((group) => ({
            id: group.id,
            modifiers: group.modifiers.map((modifier) => ({
              id: modifier.id,
              quantity: modifier.quantity,
            })),
          })),
          selectorGroups: constructor.base.selectorGroups.map((group) => ({
            id: group.id,
            modifiers: group.modifiers.map((modifier) => ({
              id: modifier.id,
            })),
          })),
        },
      })),
      cutleries: order.cutleries.map((cutlery) => ({
        complectationId: cutlery.complectation.id,
        quantity: cutlery.quantity,
        orderItemId: v4(),
      })),
      customer: user
        ? {
            name: user.fullName?.firstName || '',
            phone: user.phone,
          }
        : null,
      promotionProduct: null,
      promoCode: order.promoCode || null,
      customerCount: 1,
    },
  };
};
